import React from 'react';
import { Box, BoxProps, Container, Heading } from '@hover/blueprint';
import Slider from 'react-slick';
import { StaticImage } from 'gatsby-plugin-image';

const settings = {
  dots: false,
  infinite: true,
  dragControls: false,
  draggable: false,
  swipeToSlide: false,
  speed: 2000,
  autoplaySpeed: 2000,
  slidesToShow: 4,
  autoplay: true,
  variableWidth: true,
};

interface Props extends BoxProps {}

const Slide: React.FC<Props> = ({ children, ...restProps }) => (
  <Box {...restProps} px="50px" w="auto" h="100px">
    {children}
  </Box>
);

const TrustedByContractorsLogosSlider: React.FC = () => (
  <Container
    maxW="1200px"
    mt={1000}
    overflow="hidden"
    flexDir="column"
    alignItems="center"
  >
    <Container maxW="5xl" overflow="hidden" mb="52px">
      <Box flexDir="column" alignItems="center">
        <Heading
          maxW="5xl"
          size={{ base: 500, tablet: 700 }}
          color="neutral.700"
          textAlign="center"
          isLight
          style={{ marginBottom: 24 }}
        >
          Chosen by the names you trust in home protection and restoration
        </Heading>
        <Heading
          size={{ base: 300, tablet: 500 }}
          color="neutral.700"
          textAlign="center"
          isDisplay
          style={{ marginBottom: 0 }}
        >
          HOVER isn’t just trusted by your contractor, we’re trusted by a whole
          network of contractors. Like these right here.
        </Heading>
      </Box>
    </Container>
    <Box
      overflow="visible"
      display="block"
      width="100%"
      height="100px"
      mb={1000}
    >
      <Slider {...settings}>
        <Slide>
          <StaticImage
            quality={100}
            style={{ marginTop: 44 }}
            placeholder="blurred"
            width={170}
            height={23}
            src="../../../assets/images/state_farm_logo_1.png"
            alt="state farm logo"
          />
        </Slide>
        <Slide w="148px">
          <StaticImage
            quality={100}
            height={100}
            placeholder="blurred"
            objectFit="contain"
            src="../../../assets/images/logo_nationWide.png"
            alt="gaf logo"
          />
        </Slide>
        <Slide h="100px">
          <StaticImage
            quality={100}
            style={{ marginTop: 30 }}
            placeholder="blurred"
            width={123}
            height={35}
            src="../../../assets/images/amfam_logo.png"
            alt="srs logo"
          />
        </Slide>
        <Slide h="100px">
          <StaticImage
            quality={100}
            style={{ marginTop: 24 }}
            placeholder="blurred"
            width={162}
            height={38}
            src="../../../assets/images/travelers_vector_logo_red.png"
            alt="travelers logo"
          />
        </Slide>
        <Slide h="100px">
          <StaticImage
            style={{ marginTop: 14 }}
            placeholder="blurred"
            width={67}
            height={67}
            src="../../../assets/images/shelter-insurance.png"
            alt="owens corning logo"
          />
        </Slide>
        <Slide h="100px">
          <StaticImage
            style={{ marginTop: 28 }}
            placeholder="blurred"
            width={134}
            height={59}
            src="../../../assets/images/cincinatti_logo.png"
            alt="bacon roofing supply logo"
          />
        </Slide>
      </Slider>
    </Box>
  </Container>
);

export default TrustedByContractorsLogosSlider;
